import {useMemo} from 'react';
import {colors, radii, spacing} from '../../config/theme';
import {
  DESKTOP_CONTENT_MAX_WIDTH,
  useDesktopLayout,
} from '../../utility/useDesktopLayout';

// Screen options for the stacks inside the main tabs. On desktop web each
// screen is a centred card instead of filling the window; on mobile it's
// just `headerShown: false`.
export const useTabStackOptions = () => {
  const isDesktop = useDesktopLayout();
  return useMemo(
    () => ({
      headerShown: false,
      ...(isDesktop && {contentStyle: desktopCard}),
    }),
    [isDesktop],
  );
};

// For full-window screens (the maps): no card on desktop either.
export const FULL_WINDOW = {contentStyle: undefined};

const desktopCard = {
  width: '100%',
  maxWidth: DESKTOP_CONTENT_MAX_WIDTH,
  alignSelf: 'center',
  marginVertical: spacing.xl,
  borderRadius: radii.sheet,
  overflow: 'hidden',
  borderWidth: 1,
  borderColor: colors.border,
  backgroundColor: colors.background,
};
